export default {
  //Font imported in css file, ok to keep that way?
  fonts: {
    body: "Mulish",
    heading: "Poppins",
  },

  fontSizes: [12, 14, 16, 18, 28, 44],

  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
  },
  lineHeights: {
    body: 18,
    heading: 400,
  },
  
  colors: {
    //Colors based on design team's Figma
    white: "#FFFFFF",
    dark: "#252733",
    gray1: "#333333",
    gray2: "#4F4F4F",
    gray3: "#828282",
    gray4: "#BDBDBD",
    gray5: "#E0E0E0",
    gray6: "#F2F2F2",
    orange: "#E36054",
    yellow: "#FEC400",
    darkPink: "#FE9EA2",
    darkPurple: "#6E4884",
    pink: "#FFDDDC",
    lightPink: "#F4E5E3",
    darkBlue: "#4A55AF",
    teal: "#2DACAD",
    lightPurple: "#D5B3E7", 
    wicsOrange: "#E36054",
    babyBlue: "#D6EFFD",
  },
  inputs : {
    settingsSmall : {
      fontFamily: 'Mulish',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '20px',
      letterSpacing: '0.2px',
    },
    settingsBig: {
      fontFamily: 'Mulish',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '20px',
      letterSpacing: '0.2px',
      width: '100%',
      height: '6em',
      borderRadius: '1em',
      border: '2px solid #CCC7C7',
    }
  },
  buttons : {
    search : {
      backgroundColor: 'white',
      color: 'gray1',
      border:'none',
      fontFamily: 'Mulish',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '20px',
    },
    generic : {
      backgroundColor: 'gray6',
      color: 'gray2',
      borderColor: 'gray6',
      border: 'none',
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: 'fontSizes',
      borderRadius:'25% 25% 25% 25%',
    },
},
  space: [0, 4, 8, 16, 32, 48],
  breakpoints: ["54em", "75em", "64em", "80em"],
};